import { rest } from 'msw'
export default [
  /**
   * 特集一覧情報
   */
  rest.post('/api/v2/get_feature_list', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          items: [
            {
              id: 1,
              title: 'いつもの食品で\r\nおいしくしっかり備える',
              mainImage:
                'https://static.retailstudio.jp/assets/features/268/thumbnail_65e1a5c282b57f8dd70039fcc6dd80af.jpg',
              listImageAttribute: {
                height: 150,
                width: 150,
              },
              detailImageAttribute: {
                height: 150,
                width: 150,
              },
              openDate: '1598886000',
              closeDate: '1604070000',
              details: null,
              referenceType: 'content',
              referenceLink: '334',
            },
            {
              id: 2,
              title: '鳥取市寄附付き\r\n商品贈呈式に参加',
              mainImage:
                'https://static-stg.retailstudio.jp/assets/features/42/thumbnail_a9090ec3dea8176afb7400cf86f452e7.jpg',
              listImageAttribute: {
                height: 150,
                width: 150,
              },
              detailImageAttribute: {
                height: 150,
                width: 150,
              },
              openDate: '1598886000',
              closeDate: '1604070000',
              details: null,
              referenceType: 'content',
              referenceLink: '334',
            },
            {
              id: 3,
              title: '秋のオールグリコフェア',
              mainImage:
                'https://static.retailstudio.jp/assets/contents/626/thumbnail_d2d68fa8f0209b8abc9878c92580e4be.jpg',
              listImageAttribute: {
                height: 150,
                width: 150,
              },
              detailImageAttribute: {
                height: 150,
                width: 150,
              },
              openDate: '1598886000',
              closeDate: '1604070000',
              details: null,
              referenceType: 'content',
              referenceLink: '334',
            },
          ],
          count: 3,
          responseTime: 1600302088,
        },
      })
    )
  }),
]
